<script>
import Button from '@/Components/Button/Button';

export default {
    extends: Button,

    props: {
        type: {
            type: String,
            default: 'submit',
        },
        icon: {
            type: String,
            default: 'save',
        },
        size: {
            type: String,
            default: 'sm',
        },
        color: {
            type: String,
            default: 'green',
        },
        text: {
            type: String,
            default: function() {
                return this.$t('form.submit');
            }
        },
    },
};
</script>
